/* Ingredient Checker v2 – standalone, no React */
(function () {
  'use strict';

  var SESSION_ID = (function () {
    var c = document.cookie.split('; ').filter(function (r) { return r.startsWith('_shopify_y='); })[0];
    if (c) return c.split('=')[1];
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  })();

  /* 4 concern categories — same order as React app */
  var CATEGORIES = [
    {
      key: 'safety_in_pregnancy_flag',
      colorKey: 'safety_in_pregnancy_flag_color',
      label: 'Pregnancy Safe',
      img: 'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/pregnancy-icon.png?v=1727785527',
    },
    {
      key: 'endocrine_disruptor_potential_flag',
      colorKey: 'endocrine_disruptor_potential_flag_color',
      label: 'Endocrine Disruptors',
      img: 'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/endocrine-disruptors.png?v=1727785526',
    },
    {
      key: 'ecological_concerns_flag',
      colorKey: 'ecological_concerns_flag_color',
      label: 'Environmental Impact',
      img: 'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/environmental-impact.png?v=1727785527',
    },
    {
      key: 'system_absorption_flag',
      colorKey: 'system_absorption_flag_color',
      label: 'Body Absorption',
      img: 'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/body-absorption.png?v=1727785526',
    },
  ];

  /* ── API ── */
  function apiPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (e) { throw new Error(e.message || 'Request failed.'); });
      return res.json();
    });
  }

  function apiCheckIngredients(ingredients, productName) {
    return apiPost('https://api.chosenstore.in/kys/check-ingredients', {
      ingredients: ingredients,
      productName: productName,
      kysSessionId: SESSION_ID,
    });
  }

  function apiScanImage(image, fileName, productName) {
    return apiPost('https://api.chosenstore.in/kys/scan', {
      image: image,
      fileName: fileName,
      productName: productName,
      kysSessionId: SESSION_ID,
    });
  }

  function fileToBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onloadend = function () { resolve(reader.result); };
      reader.onerror = function () { reject(new Error('Failed to read file.')); };
      reader.readAsDataURL(file);
    });
  }

  /* ── Helpers ── */
  function rightPanel() { return document.getElementById('ingchk-v2-right'); }

  function setRight(cls, html) {
    var r = rightPanel();
    if (!r) return;
    r.className = 'ingchk-right' + (cls ? ' ' + cls : '');
    r.innerHTML = html;
  }

  function escHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function slugifyIngredient(name) {
    return String(name || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-');
  }

  /* Returns true if ingredient has any red flag across all 4 categories */
  function isIngredientFlagged(ing) {
    return CATEGORIES.some(function (cat) {
      var c = (ing[cat.colorKey] || '').toLowerCase();
      return c === 'red' || c === '#f44336' || c === '#e53935' || c === '#d32f2f';
    });
  }

  /* Build 4 category rows for one ingredient (React-style: label | dot + text) */
  function buildCategoryRows(ing) {
    return CATEGORIES.map(function (cat) {
      var dotColor = ing[cat.colorKey] || '#cccccc';
      var text = (ing[cat.key] && String(ing[cat.key]).trim()) ? ing[cat.key] : 'No Current Data';
      return '<div class="ingchk-ing-row">' +
        '<div class="ingchk-ing-row-label">' +
        '<span>' + escHtml(cat.label) + '</span>' +
        '<img src="' + cat.img + '" alt="" class="ingchk-cat-img" onerror="this.style.display=\'none\'">' +
        '</div>' +
        '<div class="ingchk-ing-row-value">' +
        '<span class="ingchk-flag-dot" style="background-color:' + escHtml(dotColor) + ';"></span>' +
        '<span class="ingchk-flag-text">' + escHtml(text) + '</span>' +
        '</div>' +
        '</div>';
    }).join('');
  }

  /* ── Panel states ── */
  var WAIT_HTML =
    '<div class="ingchk-waiting">' +
    '<div class="ingchk-waiting-icon">' +
    '<svg viewBox="0 0 24 24" fill="none" stroke="#bdbdbd" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="52" height="52"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>' +
    '</div>' +
    '<strong class="ingchk-waiting-title">Waiting for analysis</strong>' +
    '<p class="ingchk-waiting-desc">Enter your product ingredients to check their safety profile</p>' +
    '</div>';

  function showWaiting() { setRight('', WAIT_HTML); }

  function showLoading() {
    setRight('ingchk-right--loading',
      '<div class="ingchk-loading"><div class="ingchk-spinner"></div><p>Analysing ingredients…</p></div>');
  }

  function showError(msg) {
    setRight('ingchk-right--active',
      '<div class="ingchk-error">' +
      '<div class="ingchk-error-icon">⚠</div>' +
      '<p>' + escHtml(msg) + '</p>' +
      '<button class="ingchk-try-again-btn" id="ingchk-reset-btn">Try again</button>' +
      '</div>');
    var btn = document.getElementById('ingchk-reset-btn');
    if (btn) btn.addEventListener('click', showWaiting);
  }

  function showLivePreview(count) {
    var w = count === 1 ? 'ingredient' : 'ingredients';
    setRight('ingchk-right--preview',
      '<div class="ingchk-preview-card">' +
      '<div class="ingchk-pc-header">' +
      '<div class="ingchk-pc-icon ingchk-pc-icon--shield">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>' +
      '</div>' +
      '<div>' +
      '<strong class="ingchk-pc-title">Live Preview</strong>' +
      '<span class="ingchk-pc-sub">' + count + ' ' + w + ' detected</span>' +
      '</div>' +
      '</div>' +
      '<hr class="ingchk-pc-divider">' +
      '<div class="ingchk-pc-body">' +
      '<div class="ingchk-pc-notfound-box"><strong>' + count + ' ' + w + '</strong> entered &mdash; ready for safety analysis</div>' +
      '<p class="ingchk-pc-cta">Click "Check ingredients" for full analysis</p>' +
      '</div>' +
      '</div>');
  }

  function showInconclusive(data, ingredientsText) {
    var count = ingredientsText
      ? ingredientsText.split(',').map(function (s) { return s.trim(); }).filter(Boolean).length
      : (data && data.ingredients && data.ingredients.length) || 0;
    var w = count === 1 ? 'ingredient' : 'ingredients';
    setRight('ingchk-right--inconclusive',
      '<div class="ingchk-inc-card">' +
      '<div class="ingchk-inc-header">' +
      '<div class="ingchk-pc-icon ingchk-pc-icon--question">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>' +
      '</div>' +
      '<div>' +
      '<strong class="ingchk-inc-title">Inconclusive</strong>' +
      '<span class="ingchk-inc-sub">' + count + ' ' + w + ' checked</span>' +
      '</div>' +
      '</div>' +
      '<hr class="ingchk-pc-divider ingchk-pc-divider--orange">' +
      '<div class="ingchk-pc-body">' +
      '<div class="ingchk-inc-info-box">' +
      '<p>We couldn\'t verify the safety profile of these ingredients. This doesn\'t mean they\'re safe or harmful.</p>' +
      '<p class="ingchk-inc-info-sub">Try checking the manufacturer\'s website or contact them directly for safety information.</p>' +
      '</div>' +
      '<div class="ingchk-inc-tip-box"><strong>Tip:</strong> Look for products certified by recognised dermatological organisations for added assurance.</div>' +
      '</div>' +
      '</div>');
  }

  function buildResultHTML(data) {
    var ingredients = data.ingredients || [];
    var sunscreenType = data.sunscreenType || data.productType || data.formulationType || '';
    var h = '<div class="ingchk-result-scroll">';

    /* ── FORMULATION section (mirrors React app top section) ── */
    // if (sunscreenType) {
    //   h +=
    //     '<div class="ingchk-formulation">' +
    //     '<h3 class="ingchk-form-title">FORMULATION</h3>' +
    //     '<p class="ingchk-form-type">This is a <span class="ingchk-form-highlight">' + escHtml(sunscreenType) + '</span> sunscreen</p>' +
    //     '<p class="ingchk-form-desc">This contains the ingredient which qualifies this as a ' + escHtml(sunscreenType) + ' sunscreen</p>' +
    //     '</div>';
    // }

    /* ── RESULTS section — ALL ingredients shown, each with 4 category rows ── */
    h +=
      '<div class="ingchk-results-section">' +
      '<h3 class="ingchk-results-title">RESULTS</h3>' +
      '<p class="ingchk-results-sub">Here\'s how each ingredient in your formula rates</p>';

    if (ingredients.length === 0) {
      h += '<p style="text-align:center;color:#999;font-size:13px;padding:20px 0;">No ingredient data returned.</p>';
    } else {
      ingredients.forEach(function (ing) {
        var ingName = ing.name || '';
        h +=
          '<div class="ingchk-ing-card">' +
          '<div class="ingchk-ing-card-name">' + escHtml(ingName.toUpperCase()) + '</div>' +
          (ing.symbol ? '<div class="ingchk-ing-card-symbol">(' + escHtml(ing.symbol) + ')</div>' : '') +
          buildCategoryRows(ing) +
          '<div class="ingchk-learn-more" data-name="' + escHtml(ingName) + '" style="display:none">' +
          '<a class="ingchk-learn-more-link" href="#">Learn more about this ingredient &rarr;</a>' +
          '</div>' +
          '</div>';
      });
    }

    h += '</div></div>';
    return h;
  }

  function revealBlogLinks() {
    document.querySelectorAll('.ingchk-learn-more[data-name]').forEach(function (el) {
      var name = el.getAttribute('data-name');
      if (!name) return;
      fetch('/search/suggest.json?q=' + encodeURIComponent(name) +
        '&resources[type]=article&resources[options][fields]=title')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var articles = (data.resources && data.resources.results && data.resources.results.articles) || [];
          var match = null;
          /* prefer exact title match in /blogs/ingredients/ */
          for (var i = 0; i < articles.length; i++) {
            var a = articles[i];
            if (a.url && a.url.indexOf('/blogs/ingredients/') !== -1 &&
                a.title.toLowerCase() === name.toLowerCase()) {
              match = a; break;
            }
          }
          /* fallback: any article in /blogs/ingredients/ */
          if (!match) {
            for (var j = 0; j < articles.length; j++) {
              if (articles[j].url && articles[j].url.indexOf('/blogs/ingredients/') !== -1) {
                match = articles[j]; break;
              }
            }
          }
          if (match) {
            var link = el.querySelector('.ingchk-learn-more-link');
            if (link) link.href = match.url;
            el.style.display = '';
          }
        })
        .catch(function () {});
    });
  }

  function showResults(data) {
    setRight('ingchk-right--results-active', buildResultHTML(data));
    revealBlogLinks();
  }

  function triggerSections(isShow) {
    if (typeof window.showHideRecommendationSection === 'function') window.showHideRecommendationSection(isShow);
    if (typeof window.showHideFeedbacFormSection === 'function') window.showHideFeedbacFormSection(isShow);
    if (isShow && typeof window.initiateRecommendationSlider === 'function') window.initiateRecommendationSlider(true);
  }

  
  function processResult(data, ingredientsText) {
    if (data.message !== 'Success') {
      showInconclusive(data, ingredientsText);
      triggerSections(true);
      return;
    }
    data.ingredients = sortIngredientsByInputOrder(
    data.ingredients,
    ingredientsText
  );

    showResults(data);
    triggerSections(true);
  }

  function sortIngredientsByInputOrder(apiIngredients, inputText) {
    if (!inputText || !apiIngredients) return apiIngredients;

    var inputOrder = inputText
      .split(',')
      .map(function (item) {
        return item.trim().toUpperCase();
      })
      .filter(Boolean);

    return apiIngredients.slice().sort(function (a, b) {
      var aIndex = inputOrder.indexOf((a.name || '').trim().toUpperCase());
      var bIndex = inputOrder.indexOf((b.name || '').trim().toUpperCase());

      if (aIndex === -1) aIndex = 9999;
      if (bIndex === -1) bIndex = 9999;

      return aIndex - bIndex;
    });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    showWaiting();

    /* ── Tabs ── */
    var pastePanel = document.getElementById('ingchk-paste-panel');
    var uploadPanel = document.getElementById('ingchk-upload-panel');

    document.querySelectorAll('[data-ingchktab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('[data-ingchktab]').forEach(function (b) { b.classList.remove('ingchk-tab--active'); });
        this.classList.add('ingchk-tab--active');
        var t = this.getAttribute('data-ingchktab');
        if (pastePanel) pastePanel.style.display = t === 'paste' ? '' : 'none';
        if (uploadPanel) uploadPanel.style.display = t === 'upload' ? '' : 'none';
      });
    });

    /* ── Paste tab ── */
    var pasteTA = document.getElementById('ingchk-ingredients');
    var pasteBtn = document.getElementById('ingchk-check-btn');
    var clearBtn = document.getElementById('ingchk-clear-btn');
    var liveTimer = null;

    if (pasteTA && pasteBtn) {
      pasteTA.addEventListener('input', function () {
        var val = this.value.trim();
        pasteBtn.disabled = !val;
        clearTimeout(liveTimer);
        if (!val) { showWaiting(); triggerSections(false); return; }
        liveTimer = setTimeout(function () {
          var count = val.split(',').map(function (s) { return s.trim(); }).filter(Boolean).length;
          showLivePreview(count);
        }, 300);
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          pasteTA.value = '';
          var pn = document.getElementById('ingchk-product-name');
          if (pn) pn.value = '';
          pasteBtn.disabled = true;
          showWaiting();
          triggerSections(false);
        });
      }

      pasteBtn.addEventListener('click', function () {
        var ingredients = pasteTA.value.trim();
        if (!ingredients) return;
        var pn = document.getElementById('ingchk-product-name');
        pasteBtn.disabled = true;
        pasteBtn.textContent = 'Analysing…';
        showLoading();
        apiCheckIngredients(ingredients, pn ? pn.value.trim() : '')
          .then(function (data) { processResult(data, ingredients); })
          .catch(function (err) { showError(err.message || 'An error occurred.'); })
          .finally(function () {
            pasteBtn.textContent = 'Check ingredients';
            pasteBtn.disabled = !pasteTA.value.trim();
          });
      });
    }

    /* ── Upload tab ── */
    var fileInput = document.getElementById('ingchk-file-input');
    var dropZone = document.getElementById('ingchk-drop-zone');
    var uploadBtn = document.getElementById('ingchk-upload-btn');
    var filePreview = document.getElementById('ingchk-file-preview');
    var uploadClearBtn = document.getElementById('ingchk-upload-clear-btn');

    function updateUploadBtn() {
      if (uploadBtn) uploadBtn.disabled = !(fileInput && fileInput.files && fileInput.files.length);
    }

    function applyFile(file) {
      if (!file) return;
      try { var dt = new DataTransfer(); dt.items.add(file); if (fileInput) fileInput.files = dt.files; } catch (e) {}
      if (filePreview) { filePreview.textContent = '📎 ' + file.name; filePreview.style.display = 'block'; }
      updateUploadBtn();
    }

    if (fileInput) fileInput.addEventListener('change', function () { if (this.files[0]) applyFile(this.files[0]); });

    if (dropZone) {
      dropZone.addEventListener('click', function () { if (fileInput) fileInput.click(); });
      dropZone.addEventListener('dragover', function (e) { e.preventDefault(); this.classList.add('ingchk-drop-zone--hover'); });
      dropZone.addEventListener('dragleave', function () { this.classList.remove('ingchk-drop-zone--hover'); });
      dropZone.addEventListener('drop', function (e) {
        e.preventDefault();
        this.classList.remove('ingchk-drop-zone--hover');
        var f = e.dataTransfer.files[0];
        if (f) applyFile(f);
      });
    }

    if (uploadClearBtn) {
      uploadClearBtn.addEventListener('click', function () {
        if (fileInput) fileInput.value = '';
        if (filePreview) { filePreview.textContent = ''; filePreview.style.display = 'none'; }
        var pn = document.getElementById('ingchk-product-name-upload');
        if (pn) pn.value = '';
        updateUploadBtn();
        showWaiting();
        triggerSections(false);
      });
    }

    if (uploadBtn) {
      uploadBtn.addEventListener('click', function () {
        var file = fileInput && fileInput.files && fileInput.files[0];
        if (!file) return;
        var pn = document.getElementById('ingchk-product-name-upload');
        uploadBtn.disabled = true;
        uploadBtn.textContent = 'Analysing…';
        showLoading();
        fileToBase64(file)
          .then(function (b64) { return apiScanImage(b64, file.name, pn ? pn.value.trim() : ''); })
          .then(function (data) {
            var txt = (data.ingredients || []).map(function (i) { return i.name; }).join(', ');
            processResult(data, txt);
          })
          .catch(function (err) { showError(err.message || 'An error occurred.'); })
          .finally(function () {
            uploadBtn.textContent = 'Check ingredients';
            updateUploadBtn();
          });
      });
    }

    /* ── Feedback form ── */
    var feedbackForm = document.getElementById('ingredient-feedback-form');
    if (feedbackForm) {
      var fbEmail = feedbackForm.querySelector('input[name="email_phonenumber"]');
      var fbText = feedbackForm.querySelector('textarea[name="feedback"]');
      var fbSuccess = document.getElementById('feedback-result-success');
      var fbError = document.getElementById('feedback-result-error');

      feedbackForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (fbSuccess) fbSuccess.style.display = 'none';
        if (fbError) fbError.style.display = 'none';
        var emailVal = fbEmail ? fbEmail.value.trim() : '';
        var textVal = fbText ? fbText.value.trim() : '';
        var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);
        var phoneOk = /^[0-9]{10}$/.test(emailVal);
        if (!emailOk && !phoneOk) {
          if (fbError) { fbError.innerText = 'Please enter a valid email address or phone number.'; fbError.style.display = 'block'; }
          return;
        }
        if (!textVal) {
          if (fbError) { fbError.innerText = 'Please write some feedback.'; fbError.style.display = 'block'; }
          return;
        }
        var sid = (window.ShopifyAnalytics && window.ShopifyAnalytics.lib && window.ShopifyAnalytics.lib.user)
          ? window.ShopifyAnalytics.lib.user().traits().uniqToken : SESSION_ID;
        fetch('https://api.chosenstore.in/kys/user-info', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ kysSessionId: sid, userEmailOrPhone: emailVal, feedback: textVal }),
        }).then(function (r) { return r.json(); }).then(function (result) {
          if (result) {
            if (fbSuccess) { fbSuccess.innerText = 'Form submitted successfully!'; fbSuccess.style.display = 'block'; }
            feedbackForm.reset();
          } else {
            if (fbError) { fbError.innerText = 'Error submitting form. Please try again.'; fbError.style.display = 'block'; }
          }
        }).catch(function () {
          if (fbError) { fbError.innerText = 'There was an error processing your request.'; fbError.style.display = 'block'; }
        });
      });
    }

    /* ── Page-level section helpers ── */
    if (typeof window.showHideRecommendationSection !== 'function') {
      window.showHideRecommendationSection = function (isShow) {
        document.querySelectorAll('.featured-collection').forEach(function (el) {
          el.style.display = isShow ? 'block' : 'none';
        });
      };
    }
    if (typeof window.showHideFeedbacFormSection !== 'function') {
      window.showHideFeedbacFormSection = function (isShow) {
        // var fb = document.getElementById('ingredient-checker-feedback_form');
        // if (fb) fb.style.display = isShow ? 'block' : 'none';
      };
    }
  });
})();
